module.exports = __webpack_public_path__ + "static/media/bg-05.62f2e78a.png";